import toast from "react-hot-toast";

// Flag to track if session expiration error has been shown
let isSessionExpiredToastShown = false;

// Function to reset the session expired flag (useful for testing or when user logs in again)
export const resetSessionExpiredFlag = () => {
  isSessionExpiredToastShown = false;
};

export const errorHandler = {
  handleError: (error) => {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "An unexpected error occurred";

    // Skip toast for 422 password validation errors (handled by component)
    if (error.response?.status === 422 && 
        error.response?.data?.error?.details?.errors) {
      const errors = error.response.data.error.details.errors;
      const hasPasswordError = errors.some(err => err.field === 'new_password');
      
      if (hasPasswordError) {
        return error; // Don't show toast, let component handle it
      }
    }

    // Skip toast for login errors (handled by LoginPage component)
    const isLoginError = error.config?.url?.includes('/auth/login') || 
                         error.config?.url?.includes('/auth/get-user-type');
    
    if (isLoginError) {
      return error; // Don't show toast, let component handle it
    }

    // Skip toast for "No active lock found" errors (not a real error, just means lead wasn't locked)
    const isNoActiveLockError = error.config?.url?.includes('/leads/lock/unlock') && 
                                 errorMessage?.includes('No active lock found');
    
    if (isNoActiveLockError) {
      return error; // Don't show toast, this is expected behavior
    }
     // Skip toast for "No cached data found" errors (expected behavior for first-time Exposure Analysis)
    const isNoCachedDataError = error.config?.url?.includes('/schedule-hazards/') && 
                                (errorMessage?.includes('No cached data found') || 
                                 errorMessage?.includes('cached data') || 
                                 errorMessage?.includes('not yet generated') ||
                                 errorMessage?.toLowerCase().includes('exposure analysis'));
    
    if (isNoCachedDataError) {
      return error; // Don't show toast, this is expected behavior
    }

    // Skip toast for Schedule of Hazards delete 404 errors (entry already deleted or never existed)
    const isScheduleHazardsDelete404 = error.config?.method === 'delete' &&
                                        error.config?.url?.includes('/schedule-hazards/') &&
                                        error.response?.status === 404;

    if (isScheduleHazardsDelete404) {
      return error; // Don't show toast, local cleanup handles this
    }

    // Skip toast when application versions are missing (expected for brand new applications)
    const isApplicationVersionsMissing = error.response?.status === 404 &&
      error.config?.url?.includes('/duq-versioning/') &&
      !error.config?.url?.includes('/version/') &&
      !error.config?.url?.includes('/version-history/');

    if (isApplicationVersionsMissing) {
      return error; // Suppress toast, UI already shows "No version history available"
    }


    if (error.response?.status === 401) {
      toast.error(errorMessage);
    } else if (error.response?.status === 403) {
      // Show session expiration error only once
      if (!isSessionExpiredToastShown) {
        isSessionExpiredToastShown = true;
        toast.error(errorMessage);
      }
    } else if (error.response?.status === 404) {
      toast.error(errorMessage);
    } else if (error.response?.status >= 500) {
      toast.error(errorMessage);
    } else {
      toast.error(errorMessage);
    }

    return error;
  },

  handleSuccess: (message) => {
    toast.success(message);
  },

  handleWarning: (message) => {
    toast(message, { icon: "⚠️" });
  },

  handleInfo: (message) => {
    toast(message, { icon: "ℹ️" });
  },
};
